<template>
	<div class="cloud-progressManagement">
		<div class="cloud-progressManagement-top">
			<img src="@/assets/images/tunnel_select.png" alt="" />
			<el-select v-model="form.accesstype" placeholder="请选择" class="elInputSelect">
				<el-option v-for="item in tunnelOptions" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</div>

		<div class="cloud-progressManagement-title"
			style="width: 98%; height: calc(180 / 1080 * 100vh); margin-top: calc(18.5vh); margin-left: 1%; ">
			<div class="cloud-progressManagement-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
				<p>项目情况</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-progressManagement-title-content" style="overflow-y: hidden;">
				<ul class="cloud-progressManagement-title-content-ul-progressManagement">
					<li style="margin-left: 5vw !important;">
						<img src="@/assets/images/progressManagement_1.png" alt="" style="width: 4vh; height: 4vh;" />
						<div>
							<p><span>10</span>米</p>
							<p>本月施工长度</p>
						</div>
					</li>
					<li>
						<img src="@/assets/images/progressManagement_2.png" alt="" style="width: 4vh; height: 4vh;" />
						<div>
							<p><span>10</span>米</p>
							<p>本年施工长度</p>
						</div>
					</li>
					<li>
						<img src="@/assets/images/progressManagement_3.png" alt="" style="width: 4vh; height: 4vh;" />
						<div>
							<p><span>10</span>米</p>
							<p>本月产值</p>
						</div>
					</li>
					<li>
						<img src="@/assets/images/progressManagement_4.png" alt="" style="width: 4vh; height: 4vh;" />
						<div>
							<p><span>10</span>米</p>
							<p>本年产值</p>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="cloud-progressManagement-title"
			style="width: 98%; height: calc(300 / 1080 * 100vh); margin-top: calc(34.5vh); margin-left: 1%; ">
			<div class="cloud-progressManagement-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
				<p>填报情况</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-progressManagement-title-content" style="overflow-y: hidden;">
				<div class="cloud-progressManagement-title-content-table" style="margin-top: 3vh;">
					<p style="color: #fff;">项目名称</p>
					<p style="color: #fff; width: 10%;">起始里程</p>
					<p style="color: #fff; width: 17%;">当前里程</p>
					<p style="color: #fff; width: 6%;">本月施工长度</p>
					<p style="color: #fff; width: 12%;">本年施工长度</p>
					<p style="color: #fff; width: 8%;">上年施工长度</p>
					<p style="color: #fff; width: 15%;">累计施工长度</p>
				</div>
				<div class="scroll-container">
					<ul class="scroll-list">
						<li class="cloud-progressManagement-title-content-table" v-for="(item, index) in 110"
							:key="index">
							<p>龙烟隧道右边</p>
							<p>二氧化碳</p>
							<p>二衬台车</p>
							<p>10.89</p>
							<p>--</p>
							<p>10</p>
							<p>12:24</p>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="cloud-progressManagement-title"
			style="width: 98%; height: calc(320 / 1080 * 100vh); margin-top: calc(63.5vh); margin-left: 1%; ">
			<div class="cloud-progressManagement-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
				<p>进度产值分析</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-progressManagement-title-content" style="overflow-y: hidden;">
				<div id="main_gasDay" style="width: 100%; height: 30vh;"></div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import { tunnelProgress } from '@/public/api.js'

// 引入路由实例
export default {
	name: 'progressManagement',
	components: {
	},
	data() {
		return {
			myChart_GasDay: null,
			TunnelsData: [],
			form: {
				accesstype: ''
			},
			tunnelOptions: []
		}
	},
	computed: {

	},
	mounted() {
		let that = this;
		that.TunnelsData = JSON.parse(localStorage.getItem('updateLhTunnels'));

		// 初始化图表
		this.myChart_GasDay = echarts.init(document.getElementById('main_gasDay'));
		this.axisLineGasDay();
		// 监听窗口大小变化，自动调整图表
		window.addEventListener('resize', this.handleResize);
		this.getTunnelProgress();
	},
	methods: {
		getTunnelProgress() {
			let that = this;
			tunnelProgress({ itemId: that.TunnelsData.itemId }).then(res => {
				if (res.data.code == 200) {
					res.data.data.forEach((item, index) => {
						that.tunnelOptions.push({
							value: item.tunnelNumber,
							label: item?.tunnelName
						});
					});
				}
			})
		},
		axisLineGasDay() {
			let option = {
				title: {
					text: '',
					subtext: ''
				},
				tooltip: {
					trigger: 'axis',
					// 自定义tooltip内容，添加合计行
					formatter: function (params) {
						// params是当前坐标轴上所有系列的数据数组
						let total = 0; // 合计值
						let html = `<div>${params[0].name}</div>`; // 第一行显示x轴名称（如“1月”）

						// 遍历每个系列数据，累加总和并拼接单行内容
						params.forEach(item => {
							html += `<div>${item.seriesName}: ${item.value}</div>`;
							total += item.value; // 累加当前系列的值
						});

						// 添加合计行（加粗显示）
						html += `<div style="font-weight: bold; color:  #3585b3;">产值合计: ${total.toFixed(2)}</div>`;
						return html;
					}
				},
				legend: {
					show: false,
					data: []
				},
				toolbox: {
					show: false,
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
					}
				],
				yAxis: [
					{
						type: 'value'
					}
				],
				series: [
					{
						name: '开挖',
						type: 'bar',
						data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
					},
					{
						name: '仰拱',
						type: 'bar',
						data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
					},
					{
						name: '衬砌',
						type: 'bar',
						data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
					}
				]
			};


			this.myChart_GasDay.setOption(option);
		},
		// 窗口大小变化时调整图表
		handleResize() {
			if (this.myChart_GasDay) {
				this.myChart_GasDay.resize();
			}
			if (this.myChart_GasHoury) {
				this.myChart_GasHoury.resize();
			}
		},
	},
	beforeDestroy() {
		// 移除事件监听，销毁图表
		window.removeEventListener('resize', this.handleResize);
		if (this.myChart_GasDay) {
			this.myChart_GasDay.dispose();
		}
		if (this.myChart_GasHoury) {
			this.myChart_GasHoury.dispose();
		}
	}
}
</script>
<style scoped>
/* 引入字体 */
@font-face {
	font-family: 'DS-Digital';
	src: url('../font/DS-DIGIB.TTF') format('truetype');
	font-weight: normal;
	font-style: normal;
}

.cloud-progressManagement {
	width: 100%;
	height: 100%;
	text-align: left;

	.cloud-progressManagement-title {
		position: absolute;
		top: 1vh;
		left: 0;
		width: 100%;
		height: calc(920 / 1080 * 100vh);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 10px;

		.cloud-progressManagement-title-title {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 2.5vh;
			margin: 0;
			padding: 0;

			img {
				width: 100%;
				height: auto;
				margin: 0;
				padding: 0;
			}

			p {
				position: absolute;
				top: 0.3vh;
				left: 3.01vh;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;
			}
		}

		.cloud-progressManagement-title-content {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: calc(870 / 1080 * 100vh);
			margin: 0;
			padding: 0;
			overflow-y: auto;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
		}
	}

	.cloud-progressManagement-top {
		width: 98%;
		height: 80px;
		margin-top: 1vh;
		margin-left: 1%;
		background: url(@/assets/images/progressManagement_bj.png);
		background-size: 100% 100%;
		position: relative;

		>img {
			width: 20px;
			height: auto;
			margin: 0;
			padding: 0;
			position: absolute;
			top: 1.5vh;
			left: 2.5vh;
		}
	}


	::v-deep .elInputSelect {
		border: none !important;
		padding: 2px !important;
		background-color: transparent !important;
		width: 300px !important;
		margin: 10px;
		margin-left: 2vw;
		margin-top: 0vh;
		z-index: 999;
	}

	::v-deep .elInputSelect .el-input__inner {
		background-color: transparent !important;
		border: 0px solid #3585b3;
		color: #fff;
	}

	::v-deep .elInputSelect .el-input-group__append {
		background-color: transparent !important;
		border: 0px solid #3585b3;
	}

	::v-deep .el-input__inner {
		background-color: #082435 !important;
		border: 0px solid #3585b3 !important;
	}

	::v-deep .el-form-item {
		margin-bottom: 0px;
	}

	.cloud-progressManagement-title-content-ul-progressManagement {
		list-style: none;
		margin: 0;
		padding: 0;

		>li {
			position: relative;
			margin: 0;
			padding: 0;
			text-align: left;
			float: left;
			width: calc(25% - 2vw);
			height: calc(100 / 1080 * 100vh);
			margin: 0;
			padding: 0;

			>img {
				width: 4vw !important;
				height: 8vh !important;
				margin: 0;
				padding: 0;
				position: absolute;
				top: 4vh;
				left: 0.5vw;
				float: left;
			}

			>div {
				position: absolute;
				top: 4.5vh;
				left: 5.5vw;
				width: 60%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;

				>p {
					margin: 0;
					padding: 0;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 0.8rem;
					font-style: normal;
					text-transform: none;
				}

				>p:nth-child(1) {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 0.8rem;
					color: #EBFF36;
					text-align: left;
					font-style: normal;
					text-transform: none;
					margin-bottom: 0.6vh;

					>span {
						font-family: DS-Digital, DS-Digital;
						font-weight: 400;
						font-size: 2.2rem !important;
						color: #dfef05;
						font-style: normal;
						text-transform: none;
						padding-right: 0.5vw;
					}
				}
			}
		}
	}

	.cloud-progressManagement-title-content-table {
		width: 100%;
		height: 2.5vh;
		margin: 0;
		padding: 0;
		margin-top: 1vh;
		text-align: center;

		>p {
			height: 2.5vh;
			margin: 0;
			padding: 0;
			float: left;
			line-height: 2.5vh;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 0.9rem;
			color: rgba(255, 255, 255, 0.6);
			text-align: center;
			font-style: normal;
			text-transform: none;
		}

		>p:nth-child(1) {
			width: 18%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(2) {
			width: 14%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(3) {
			width: 15%;
		}

		>p:nth-child(4) {
			width: 10%;
		}

		>p:nth-child(5) {
			width: 10%;
		}

		>p:nth-child(6) {
			width: 10%;
		}

		>p:nth-child(7) {
			width: 15%;
		}

	}

		.scroll-container {
		width: 93%;
		height: 18vh;
		overflow-y: auto;
		scrollbar-width: thin;
		scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
		list-style: none;
		padding: 0;
		margin: 0;
	}

	/* 滚动列表：包裹所有项并执行动画 */
	::v-deep .scroll-list {
		margin: 0;
		padding: 0;
		list-style: none;
		animation: scrollUp 100s linear infinite;
		/* 滚动动画 */
	}

	/* 鼠标悬停暂停动画 */
	.scroll-container:hover .scroll-list {
		animation-play-state: paused;
	}
}
</style>